import { env } from "@/constants/env";

export const appEnv = {
  isDevelopment: env.APP_ENV === "development",
  isStaging: env.APP_ENV === "staging",
  isProduction: env.APP_ENV === "production",
};
